import React from "react";
import {Box, IconButton, Menu, MenuItem, Theme, useTheme} from "@mui/material";
import {palette} from "../../technical/style/theme";
import {useAccount} from "../../../administration/users/AccountProvider";
import PersonIcon from '@mui/icons-material/Person';
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import {useUserManager} from "../../technical/auth/UserManagerContext";
import {formatUser} from "../../../administration/users/User";
import {useApplicationFormatter} from "../../../administration/applications/ApplicationProvider";
import {getAccountServiceRole} from "../../../administration/users/AccountServiceRoles";

const cardStyle = (theme: Theme) => ({
  display: 'flex',
  minWidth: '150px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: 1,
  color: palette.primary,
  borderColor: palette.primary,
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingRight: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  marginRight: theme.spacing(2),
  whiteSpace: 'nowrap',
  ...palette.greyTextOpacity
});

export function UserCard() {
  const account = useAccount();
  const applicationFormatter = useApplicationFormatter();
  const theme = useTheme();
  const {t} = useTranslation();
  const userManager = useUserManager();
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);

  const closeMenu = () => {
    setMenuAnchorEl(null);
  };

  return (
    <Box sx={cardStyle(theme)}>
      <Box sx={{marginRight: theme.spacing(1), display: 'flex', alignItems: 'center',}}>
        <IconButton
          size={'small'}
          edge="start"
          color="inherit"
          onClick={ev => setMenuAnchorEl(ev.currentTarget)}
        >
          <PersonIcon />
        </IconButton>
      </Box>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'left', fontWeight: 'normal',}}>
        <Typography variant={"caption"} style={{fontWeight: 'bolder'}}>{formatUser(account)}</Typography>
        <Typography variant={"caption"}>{applicationFormatter.formatApplicationRole(getAccountServiceRole(account))}</Typography>
      </Box>
      <Menu
        anchorEl={menuAnchorEl}
        keepMounted
        open={Boolean(menuAnchorEl)}
        onClose={closeMenu}
      >
        <MenuItem
          onClick={() => userManager.signoutRedirect({
            post_logout_redirect_uri: `${window.location.href}`
          })}
        >
          {t('menu.logout')}
        </MenuItem>
      </Menu>
    </Box>
  )
}
